import '../assets/css/product-card.css';

import { Link } from 'react-router-dom';
import { Price , W_Time} from '../../assets/icones/icones';
import React from "react";
import {FormatNumberByhkh} from "../../clientconfigwebapp";

const Mycourse_post = (props) => {


    let link_post_get="/" + props.link_to;
    link_post_get=link_post_get.replaceAll("//","")



    return (
        <>
            <div className='flexColBetStart course-card'>
                <div className='course-img'>
                <span className='flexRowBetCenter'>
                    <W_Time />
                    { props.item_post.training_hours &&  (props.item_post.training_hours)}
                </span>
                    <Link  className={"course-card-title"} to={link_post_get}>
                    <img className={"img-post-card"} src={props.img_src}  />
                    </Link>
                </div>
                <div>
                    <Link  className={"course-card-title"} to={link_post_get}>{props.title}</Link>
                    <p className={"summeary_text_cardbox contentdotline contentdotline-1"}>{props.summery_text}</p>
                </div>
                <div className='flexRowBetCenter course-footer'>
                    <Link reloadDocument={true} to={link_post_get} >مشاهده دوره</Link>
                </div>
            </div>
        </>
    );
}

export default Mycourse_post;